<template>
    <div class="page">
        <!--<div class="page-hd">-->
            <!--<myNav>{{title}}</myNav>-->
        <!--</div>-->
        <div class="page-bd">
            <!--<Button type="primary" @click="openSave('add',title)">{{$t("add")}} {{title}}</Button>-->
            <div class="tree-box">
                <div v-for="item in listData" :key="item.org_id">
                    <span><Icon class="left-icon" type="ios-arrow-down" />{{item.org_cname}}
                        <span class="tag primary fr" @click="openAdd(item)">{{$t("add_role")}}</span>
                    </span>
                    <div v-show="item.roles.length > 0">
                        <Tag class="tag-role" color="success" v-for="(role,index) in item.roles" :key="index" type="dot" :name="role.role_id" closable @on-close="()=> {closeRole(item, role)}">
                            {{`[${role.cat_cname || `${$t('self')}`}] ${role.role_cname}`}}
                            <a style="color: blue" @click="setFunc(item, role)">{{$t('configure')}}</a>
                        </Tag>
                    </div>
                    <div class="sub-tree c1" v-for="item2 in item.downs" :key="item2.org_id">
                        <span><Icon class="left-icon" type="ios-arrow-down" />{{item2.org_cname}}
                             <span class="tag primary fr" @click="openAdd(item2)" >{{$t("add_role")}}</span>
                        </span>
                        <div v-show="item2.roles.length > 0">
                            <Tag class="tag-role" color="success" v-for="(role,index) in item2.roles" :key="index" type="dot" :name="role.role_id" closable @on-close="()=> {closeRole(item2, role)}">
                                {{`[${role.cat_cname || `${$t('self')}`}] ${role.role_cname}`}}
                                <a style="color: blue" @click="setFunc(item2, role)">{{$t('configure')}}</a>
                            </Tag>
                        </div>
                        <div class="sub-tree c2" v-for="item3 in item2.downs" :key="item3.org_id">
                            <span><Icon class="left-icon f-yellow" type="ios-ribbon" />{{item3.org_cname}}
                                <span class="tag primary fr" @click="openAdd(item3)">{{$t("add_role")}}</span>
                            </span>
                            <div v-show="item3.roles.length > 0">
                                <Tag class="tag-role" color="success" v-for="(role,index) in item3.roles" :key="index" type="dot" :name="role.role_id" closable @on-close="()=> {closeRole(item3, role)}">
                                    {{`[${role.cat_cname || `${$t('self')}`}] ${role.role_cname}`}}
                                    <a style="color: blue" @click="setFunc(item3, role)">{{$t('configure')}}</a>
                                </Tag>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <Drawer class="drawer-sub-view" :title="sub_title" v-model="show_subview" width="720" :mask-closable="false" placement="left" :closable="false">
            <router-view></router-view>
        </Drawer>
    </div>
</template>

<script>
    import myNav from "../../../components/myNav"
    import myToolbar from '../../../components/myToolbar'
    import myNodata from '../../../components/myNodata'
    export default {
        name:"org-downroles2",
        components:{
            myNav,
            myToolbar,
            myNodata,
        },
        data:function(){
            return{
                title: this.$t('downrole'),
                sub_title:"",//子界面名称
                show_subview:false,
                relist:false,
                search:{
                    search_url:'down-role-s2/list'
                },
                listData: [],
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.list();
        },
        methods:{
            list: function () {
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.list;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            openAdd: function (item) {
                let url = 'downroles2/adddownroles2';
                this.sub_title = this.$t('add_new_role');
                this.$base.linkTo(url,{org_cname: item.org_cname, org_id: item.org_id});
            },
            setFunc: function (item, role) {
                this.sub_title = this.$t('configure');
                this.$base.linkTo('downroles2/downroles2func',{org_id: item.org_id, role_id: role.role_id, role_cname: role.role_cname, org_cname: item.org_cname, cat_cname: role.cat_cname});
            },
            closeRole: function (item, role) {
                this.sub_title = this.$t('del');
                this.$base.linkTo('downroles2/downroles2delete',{org_id: item.org_id, role_id: role.role_id, role_cname: role.role_cname, org_cname: item.org_cname, cat_cname: role.cat_cname});
            },
        },

        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(this.search.page);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>
    .tree-box{
        max-width: 600px;
    }
    .tag-role{
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/org/downrole/lists2.vue